// UserStatusBadge.js
import React from 'react';
import { Flex, Space } from 'antd';

const UserStatusBadge = ({ status, showStatus, font_size, show = false }) => {
  // const timeAgo = useAppStore((state) => state.timeAgoText);
  const statusConfig = {
    away: {
      badgeName: "Away",
      iconClass: "fa-solid fa-clock",
      color: "rgb(255, 212, 59)",
    },
    online: {
      badgeName: "Online",
      iconClass: "fa-solid fa-check-circle",
      color: "green",
    },
    do_not_disturb: {
      badgeName: "Do Not Disturb",
      iconClass: "fa-solid fa-circle-minus",
      color: "red",
    },
    offline: {
      badgeName: "Offline",
      iconClass: "fa-regular fa-circle",
      color: "grey",
    },
    busy: {
      badgeName: "Busy",
      iconClass: "fa-solid fa-circle-minus",
      color: "blue",
    }
  };

  // Default to offline if status is not recognized
  const { badgeName, iconClass, color } = statusConfig[status?.toLowerCase()] || statusConfig.offline;

  return (
    <>
      <Flex align='center' gap='4px' className="avatar-badge-status">
        <i className={ iconClass } style={ { color: color ?? "#FFD43B", fontSize: font_size } }></i>
        {(showStatus && badgeName)}
        {/* { timeAgo && badgeName == "Offline" && show ? ("Last online" + " " + timeAgo) : (showStatus && badgeName) } */}

      </Flex>
    </>
  );
};

export default UserStatusBadge;
